import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { Recipe } from 'reducers/menu-recipes/recipes'

export const useTrackSoldOutRecipesEffect = (recipes: Recipe[]) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const soldOutRecipes = recipes
      .filter((recipe) => !recipe.isAvailable)
      .map((recipe) => recipe.coreId)

    if (!soldOutRecipes?.length) return

    dispatch({
      type: actionTypes.TRACKING,
      trackingData: {
        actionType: trackingKeys.soldOutRecipes,
        soldOutRecipes,
      },
    })
  }, [recipes, dispatch])
}
